import { Injectable } from '@angular/core';

import { BehaviorSubject, Subscription } from 'rxjs';
import { map } from 'rxjs/operators';
import { WebSocketService } from './web-socket.service';

@Injectable({
  providedIn: 'root',
})
export class LogsService {
  private logsSubscription: Subscription;
  private $messages: BehaviorSubject<any[]> = new BehaviorSubject([]);

  constructor(public wsService: WebSocketService) {
    this.logsSubscription = this.wsService.listen('log_msg').subscribe((message) => {
      if (message == null) {
        return;
      }
      if (typeof message === 'string') {
        message = JSON.parse(message);
      }
      if (Array.isArray(message)) {
        message.forEach(processMessage);
      } else {
        processMessage(message);
      }
    });

    // processMessage guarda uno a uno un número máximo de logs en el servicio.
    const processMessage = (msg: any) => {
      if (msg == null) {
        return;
      }
      const payload = {
        date: this.getTimeStamp(),
        from: this.getType(msg),
        msg,
      };

      this.$messages.next(this.$messages.getValue().concat([payload]));

      if (this.$messages.getValue.length > 200) {
        const msgArray: any[] = this.$messages.getValue();
        msgArray.splice(0, 1);
        this.$messages.next(msgArray);
      }
    };
  }

  ngOnDestroy() {
    this.logsSubscription.unsubscribe();
  }

  getMessages() {
    return this.$messages.asObservable().pipe(map((logs) => logs));
  }

  getMessageByEvent(event: string) {
    return this.wsService.listen(event);
  }

  getType(message: any): string {
    switch (message.msg_type) {
      case 'req_state': {
        return 'Servmat';
      }
      case 'state': {
        return 'Servmat';
      }
      case 'change': {
        return 'Servmat';
      }
      case 'auth_request': {
        return 'Servmat';
      }
      case 'auth_response': {
        return 'AuthServer';
      }
      case 'open': {
        return 'AuthServer';
      }
      case 'close': {
        return 'AuthServer';
      }
      case 'start': {
        return 'Servmat';
      }
      case 'stop': {
        return 'Servmat';
      }
      case 'result': {
        return 'OCRServer';
      }
      case 'incidence': {
        return '***';
      }
    }
  }

  getTimeStamp(): object {
    const now: Date = new Date();
    const date: string[] = [now.getDay().toString(), (now.getMonth() + 1).toString(), now.getFullYear().toString()];
    // console.log (date);

    const hours: string = ('0' + now.getHours().toString()).slice(-2);
    const minutes: string = ('0' + now.getMinutes().toString()).slice(-2);
    const seconds: string = ('0' + now.getSeconds().toString()).slice(-2);
    const milis: string = ('0' + now.getMilliseconds().toString()).slice(-2);

    const time: string[] = [hours, minutes, seconds, milis];

    return {
      date: date.join('/'),
      time: time.join(':'),
    };
  }
}
